const enhancedChartStyle = {};

export default enhancedChartStyle;
